

import * as THREE from 'three';
import { ARButton } from "three/examples/jsm/webxr/ARButton"
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js';
import { useEffect, useRef, useState } from 'react';

import arimg from "../assets/2.png"
import './Viewer.css';
import loadimg from "../assets/augmented-reality.png"

export default function Webxr() {
    const arInstructionRef = useRef();
    const [progress, setProgress] = useState(0);
    const [surfaceDetected, setSurfaceDetected] = useState(false);
    const [isInARMode, setIsInARMode] = useState(false);
    const reticleRef = useRef();
    const current_object = useRef();
    const renderer = useRef();
    const isAR = useRef(false);
    const firstPlaced = useRef("notplaced");
    const [isLoading, setIsLoading] = useState(true);
    const [isSearching, setIsSearching] = useState(false);
    // const [firstPlaced, setfirstPlaced] = useState("notplaced");



    let door = ['model/Vepod_03.glb']



    const OpenAR = () => {

        document.getElementById('ARButton').click()
        current_object.current.visible = false;
        renderer.current.xr.enabled = true;
        isAR.current = true;
        current_object.current.position.y = 0;
        setIsSearching(true)
        firstPlaced.current = "notplaced"
    }


    var container;
    let camera, scene;
    var reticle, pmremGenerator, controls, envmap;
    var hitTestSource = null;
    let hitTestSourceRequested = false;



    useEffect(() => {


        init();
        animate();
        loadModel(door[0])

        if (document.querySelector("#ARButton")) {
            document.querySelector("#ARButton").style.opacity = 0
            // document.querySelector("#ARButton").style.backgroundColor = "red"
            // document.querySelector("#ARButton").style.bottom = '100px'
            // document.querySelector("#ARButton").style.zIndex = -1
            // document.querySelector("#ARButton").style.position = 'unset'


        }



        document.getElementById('place-button').addEventListener("click", function () {
            arPlace();
        })
    }, [])





    function arPlace() {
        if (reticle.visible) {
            current_object.current.position.setFromMatrixPosition(reticle.matrix);
            current_object.current.position.y = -2.2;
            current_object.current.visible = true;
            setIsSearching(false)
            firstPlaced.current='initialplaced'

        }
    }

    function loadModel(model) {

        var loader = new GLTFLoader()

        loader.load(
            model,
            function (glb) {
                glb.scene.name = model;
                current_object.current = glb.scene;
                current_object.current.position.set(0, -2.2, 0);
                scene.add(current_object.current);
                arPlace();
                setProgress(100); // اضافه کردن این خط برای اطمینان از رسیدن به 100%
                setIsLoading(false)
                render();
            },
            function (xhr) {
                if (xhr.lengthComputable) {
                    // محدود کردن مقدار بین 0 تا 100
                    const percentComplete = Math.min(100, Math.max(0, Math.round((xhr.loaded / xhr.total) * 100)));
                    console.log('Loading progress:', percentComplete);
                    setProgress(percentComplete);
                    setIsLoading(true)

                } else {
                    // روش جایگزین با محدودیت
                    const estimatedTotal = xhr.total || 1000000;
                    const percentComplete = Math.min(100, Math.max(0, Math.round((xhr.loaded / estimatedTotal) * 100)));
                    setProgress(percentComplete);
                    setIsLoading(true)

                }
            },
            function (error) {
                console.error('Error loading model:', error);
                setProgress(0); // بازنشانی به صفر در صورت خطا
                setIsLoading(true)


            }
        );
    }

    function init() {
        container = document.createElement('div');
        document.getElementById("container").appendChild(container);
        scene = new THREE.Scene();
        scene.environment = new RGBELoader().load('christmas_photo_studio_07_1k.hdr');
        scene.environment.mapping = THREE.EquirectangularReflectionMapping;
        window.scene = scene;
        camera = new THREE.PerspectiveCamera(70, document.body.offsetWidth / document.body.offsetHeight, 0.001, 200);
        camera.position.set(0, 0, 3)
        renderer.current = new THREE.WebGLRenderer({ antialias: true, alpha: true });
        renderer.current.setPixelRatio(window.devicePixelRatio);
        renderer.current.setSize(document.body.offsetWidth, document.body.offsetHeight);
        // renderer.current.xr.enabled = true;
        container.appendChild(renderer.current.domElement);

        pmremGenerator = new THREE.PMREMGenerator(renderer.current);
        pmremGenerator.compileEquirectangularShader();

        controls = new OrbitControls(camera, renderer.current.domElement);
        // controls.addEventListener('change', render);
        // controls.minDistance = 2;
        // controls.maxDistance = 10;
        controls.target.set(0, 0, -0.2);
        controls.enableDamping = true;
        controls.dampingFactor = 0.05;


        //AR SETUP

        let options = {
            requiredFeatures: ['hit-test'],
            optionalFeatures: ['dom-overlay'],
        }

        options.domOverlay = { root: document.getElementById('contents') };

        document.body.appendChild(ARButton.createButton(renderer.current, options));



        reticle = new THREE.Mesh(
            new THREE.RingGeometry(0.15, 0.2, 32).rotateX(- Math.PI / 2),
            new THREE.MeshBasicMaterial()
        );
        reticle.matrixAutoUpdate = false;
        reticle.visible = false;
        scene.add(reticle);

        //

        window.addEventListener('resize', onWindowResize, false);

        let touchX = 0, touchY = 0;
        let prevDistance = 0;
        let touchDown = false;

        renderer.current.domElement.addEventListener('touchstart', function (e) {
            console.log('touchstart')
            if (e.touches.length === 1) {
                touchDown = true;
                touchX = e.touches[0].pageX;
                touchY = e.touches[0].pageY;
            } else if (e.touches.length === 2) {
                const dx = e.touches[0].pageX - e.touches[1].pageX;
                const dy = e.touches[0].pageY - e.touches[1].pageY;
                prevDistance = Math.sqrt(dx * dx + dy * dy);
            }
        }, false);



        let isTwoFinger = false; // برای تشخیص ورود جدید به حالت دو انگشتی
        //test2
        renderer.current.domElement.addEventListener('touchmove', function (e) {
            if (!current_object.current) return;

            e.preventDefault();

            if (e.touches.length === 1) {
                if (!touchDown || isTwoFinger) {
                    // از دو انگشت یا عدم لمس به یک انگشت سوییچ کرده
                    touchY = e.touches[0].pageY;
                    touchDown = true;
                    isTwoFinger = false;
                    return;
                }

                const newY = e.touches[0].pageY;
                const deltaY = newY - touchY;
                touchY = newY;

                current_object.current.position.y += deltaY * -0.002;

            } else if (e.touches.length === 2) {
                if (!isTwoFinger) {
                    // تازه وارد حالت دو انگشتی شدیم
                    const dx = e.touches[0].pageX - e.touches[1].pageX;
                    const dy = e.touches[0].pageY - e.touches[1].pageY;
                    prevDistance = Math.sqrt(dx * dx + dy * dy);
                    touchX = (e.touches[0].pageX + e.touches[1].pageX) / 2;
                    isTwoFinger = true;
                    touchDown = false;
                    return;
                }

                const dx = e.touches[0].pageX - e.touches[1].pageX;
                const dy = e.touches[0].pageY - e.touches[1].pageY;
                const newDistance = Math.sqrt(dx * dx + dy * dy);

                const zoomDelta = newDistance - prevDistance;
                prevDistance = newDistance;

                let scaleFactor = 1 + zoomDelta * 0.005;
                current_object.current.scale.multiplyScalar(scaleFactor);

                const newTouchX = (e.touches[0].pageX + e.touches[1].pageX) / 2;
                const avgDeltaX = newTouchX - touchX;
                touchX = newTouchX;

                current_object.current.rotation.y += avgDeltaX * 0.01;
            }
        }, false);

        renderer.current.domElement.addEventListener('touchend', function (e) {
            console.log('touchend')

            if (e.touches.length === 0) {
                touchDown = false;
            }
        }, false);



    }



    function onWindowResize() {

        camera.aspect = document.body.offsetWidth / document.body.offsetHeight;
        camera.updateProjectionMatrix();

        renderer.current.setSize(document.body.offsetWidth, document.body.offsetHeight);

    }

    function animate() {
        renderer.current.setAnimationLoop(render);
        requestAnimationFrame(animate);
        controls.update();

    }
    useEffect(() => {
        if (arInstructionRef.current) {
            arInstructionRef.current.style.display = 'block';
        }
    }, []);


    function render(timestamp, frame) {
        console.log(' isAR.current frame reticle', reticle, isAR.current, frame)
        console.log('hitTestSourceRequested ,hitTestSource', hitTestSourceRequested, hitTestSource)
        if (frame && isAR.current) {

            console.log(current_object.current.position);
            var referenceSpace = renderer.current.xr.getReferenceSpace();
            var session = renderer.current.xr.getSession();


            if (hitTestSourceRequested === false) {
                setIsSearching(true);

                session.requestReferenceSpace('viewer').then(function (referenceSpace) {

                    session.requestHitTestSource({ space: referenceSpace }).then(function (source) {

                        hitTestSource = source;

                    });

                });

                session.addEventListener('end', function () {

                    renderer.current.xr.enabled = false;

                    hitTestSourceRequested = false;
                    hitTestSource.cancel()
                    hitTestSource = null;

                    isAR.current = false;
                    setIsSearching(false)

                    reticle.visible = false;
                    firstPlaced.current = "no"


                    if (current_object.current != null) {
                        scene.remove(current_object.current);
                    }
                    loadModel(current_object.current.name)

                    document.getElementById("place-button").style.display = "none";
                    document.getElementById("contents").style.display = "block";

                    camera.position.set(0, 0, 2)
                    camera.rotation.set(0, 0, 0)
                    camera.aspect = document.body.offsetWidth / document.body.offsetHeight;
                    camera.updateProjectionMatrix();

                    renderer.current.setSize(document.body.offsetWidth, document.body.offsetHeight);





                });

                hitTestSourceRequested = true;

            }
            if (hitTestSource) {

                var hitTestResults = frame.getHitTestResults(hitTestSource);


                if (hitTestResults.length) {
                    setIsSearching(false);
                    var hit = hitTestResults[0];

                    document.getElementById("place-button").style.display = "block";

                    reticle.visible = true;

                    reticle.matrix.fromArray(hit.getPose(referenceSpace).transform.matrix);

                } else {
                    if (firstPlaced.current === "initialplaced"){
                        setIsSearching(false);
                    }
                    else if(firstPlaced.current === "notplaced"){
                        setIsSearching(true);

                    }else{
                        setIsSearching(false);

                    }
                       


                    reticle.visible = false;

                    document.getElementById("place-button").style.display = "none";

                }

            }

        }


        renderer.current.render(scene, camera);

    }



    return (

        <>


            <div className="viewer-container">
                {isLoading && (
                    <div id="custom-loader">
                        <div className="spinner-wrapper">
                            <div className="spinner"></div>
                            <p className="loading-text">{progress}%</p>
                        </div>
                    </div>
                )}

                <div className="panelTop" id="panelTop">
                    <div className="ar-button-container">
                        <img
                            src={arimg}
                            onClick={OpenAR}
                            alt="AR Button"
                            className="ar-button"
                        />
                    </div>


                </div>

                <div id="contents">


                    {isSearching && (
                        <div
                            ref={arInstructionRef}
                            style={{

                                position: "fixed",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                zIndex: 10000, // مقدار بسیار بالا برای اطمینان
                                color: "white", // رنگ متن را تغییر دهید
                                textAlign: "center",
                                backgroundColor: "rgba(0,0,0,0)", // پس‌زمینه نیمه شفاف
                                padding: "0px",
                                borderRadius: "10px",
                            }}
                        >
                            <img
                                src={loadimg}
                                alt="AR Guide"
                                style={{
                                    zIndex: 10001,
                                    width: "80px",
                                    marginBottom: "10px",

                                }}
                            />
                            <p style={{ fontSize: "15px" }}>دوربین را به سمت سطح بگیرید</p>
                        </div>
                    )}



                    <div id="container" style={{ zIndex: 0 }}></div>

                    <button type="button" id="place-button">جای‌گذاری</button>
                </div>
            </div>





        </>

    )
}